import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const coordinatesApi = createApi({
  reducerPath: "coordinates",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/coordinates/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    createPestCoord: builder.mutation({
      query: (coordinates) => ({
        url: "create",
        body: coordinates,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "POST",
      }),
    }),
    createDiseaseCoord: builder.mutation({
      query: (coordinates) => ({
        url: "createDiseaseCoord",
        body: coordinates,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "POST",
      }),
    }),
    createWeedCoord: builder.mutation({
      query: (coordinates) => ({
        url: "createWeedCoord",
        body: coordinates,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreatePestCoordMutation,
  useCreateDiseaseCoordMutation,
  useCreateWeedCoordMutation,
} = coordinatesApi;
